import { personalIncomeTax, socialContribution } from "./soleproprietorshiptaxes";
import { Taxes, calculateTaxes } from "./taxes";
import { TaxesInput } from "./taxesinput";
import { administrationCost, corporationBrackets, smallCorporationBrackets, smallCorporationMinimalAllowance, withHoldingBrackets } from "./taxesmasterdata";

export function corporationTax(profit: number, allowance: number): number {
    if (allowance > profit || allowance > smallCorporationMinimalAllowance) {
        return calculateTaxes(profit, smallCorporationBrackets)
    }
    return calculateTaxes(profit, corporationBrackets)
}

export function withHoldingTax(profit: number, corporationTax: number): number {
    return calculateTaxes(profit - corporationTax, withHoldingBrackets)
}

export function calculateCorporationTaxes(input: TaxesInput): Taxes {
    const profit = input.turnOver - input.expenses - input.allowance

    const corpTax = corporationTax(profit, input.allowance)

    return new Taxes(
        socialContribution(input.allowance, input.typeOfActivity),
        personalIncomeTax(input.allowance, input.dependents),
        corpTax + withHoldingTax(profit, corpTax),
        administrationCost)
}